import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { z } from 'zod';

export const DataSets = z.object({
  dataSets: z.array(DataSet),
  dataSetVersions: z.record(z.string(), z.array(z.string())),
});

export type DataSets = z.infer<typeof DataSets>;

export const DataSetType = z.enum([
  'Supplemental',
  'Integration',
  'File',
  'Composite',
]);

export type DataSetType = z.infer<typeof DataSetType>;

export const DataSetTypes = Object.values(DataSetType.Values);
